import { acceptState } from "../../../components/AutoComplete/accept-state.ts"
import { type SuggestionAddress } from "../../../components/AutoComplete/AddressAutoComplete.tsx"
import { suggestionZip } from "../../../components/AutoComplete/suggestion-zip.ts"

interface AddressSuggestionValues {
  address: string | null
  city: string | null
  state: string | null
  zip_code: string | null
}

/**
 * An unrecognised state is dropped for the user to pick instead. `address_2` is
 * never part of a suggestion and is left as the user typed it.
 */
const applyAddressSuggestion = (
  suggestion: SuggestionAddress,
  knownStates: string[] = []
): AddressSuggestionValues => {
  const state = suggestion?.address?.state || null
  const accepted = acceptState(state, knownStates)

  return {
    address: suggestion?.address?.street || null,
    city: suggestion?.address?.city || null,
    state: accepted ? state : null,
    zip_code: suggestionZip(suggestion)
  }
}

export { type AddressSuggestionValues, applyAddressSuggestion }
